"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorsCopy = void 0;
exports.errorsCopy = {
    fetchError: 'The server could not be reached, please try again later.'
};
